import React from "react";
import { useNavigate } from "react-router-dom";
import Btn from "../../components/common/Btn";
import HeadCont from "../../components/common/HeadCont";
import IdCard from "../../components/result/IdCard";

const Register = () => {
    const navigate = useNavigate();

  return (
    <>
      <HeadCont rightIcon={"no icon"} />
      <section className="mb-6 safe-area-mt-header space-y-6 p-6">
        <h2 className="text-subtitle3 text-gray_180">{"Welcome to Healiary!"}</h2>
        <p className="text-body2_700l text-gray_160">
          {"Your health profile has been created!"}
          <br />
          {"Complete the health questionnaire to personalize your experience."}
        </p>
        <IdCard />
        <Btn
          id={"signUpDone"}
          bgColor={"bg-main"}
          textColor={"text-white"}
          borderColor={"border border-main"}
          title={"Complete"}
          active={"on"}
          onAction={() => navigate(`/home`)}
        />
      </section>
    </>
  );
};

export default Register;
